const transformErrors = (errors) =>
  errors.map((error) => {
    if (error.name === 'pattern') {
      error.message = 'Invalid format';
    }
    return error;
  });

export default transformErrors;
